import { useDeleteApprovedVendorMutation } from "@common/api/approved-vendors"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/approved-vendors/delete/$vendorId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "approved_vendor:delete", "/"),
  component: DeleteVendorDialog,
})

function DeleteVendorDialog(): React.ReactElement {
  const { vendorId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteApprovedVendorMutation()

  const close = () => navigate({ to: "/approved-vendors", search: true })

  return (
    <DeleteDialog
      noun="vendor"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { vendor_id: vendorId },
          {
            onSuccess: () => {
              showToast("Deleted", "Vendor deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
